// extracted by mini-css-extract-plugin
export default {"fadein":"fadein_fadein__amFR7","isVisible":"fadein_isVisible__1xRUD"};